import React, { Component } from "react";
import Recaptcha from "react-recaptcha";
import FacebookLogin, { ReactFacebookLoginInfo } from "react-facebook-login/dist/facebook-login-render-props";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import cn from "classnames";
import { History } from "history";

import Seo from "../../../common/helpers/seo";
import {
    reg_email,
    recaptchaSiteKey,
    facebookAppId,
    fields,
    emailProviderValidator,
} from "../../../common/parameters";
import { TApp } from "../../../common/types";
import { getAppFromHistory, getAppPrefix } from "../../../common/app";

import routing from "../../routing";
import Icon from "../../icon";
import Form, {
    InputText,
    InputPassword,
    Submit,
    Cancel,
    Validation,
    Checkbox,
    FormWrapper,
} from "../../components/Form";
import Method from "../../components/Method";
import { ICheckboxEvent } from "../../types";

import { StyledSignup, StyledRecaptcha } from "./styles";
import messages from "./messages";
import { IProps, IState } from "./interfaces";
import { TokenResponse } from "@react-oauth/google";
import GoogleButton from "./GoogleButton";

let $script = (a: string, b: string) => null;
if (process.env.WEBPACK) {
    $script = require("scriptjs");
}

class Signup extends Component<IProps, IState> {
    app: TApp = undefined;
    constructor(props: IProps) {
        super(props);
        this.app = getAppFromHistory(props.history);
        if (props.user.loggedIn) {
            if (props.user.profiled) {
                switch (this.app) {
                    case "memory": {
                        props.history.replace("/" + routing.memory + "/" + routing.choirs);
                        break;
                    };
                    default: {
                        props.history.replace("/" + routing.dashboard);
                    };
                }
            } else {
                switch (this.app) {
                    case "memory": {
                        props.history.replace("/" + routing.memory + "/" + routing.signupProfile);
                        break;
                    }
                    default: {
                        props.history.replace("/" + routing.signupProfile);
                    }
                }
            }
        }
    }
    state: IState = {
        email: "",
        password: "",
        password2: "",
        accept: false,
        recaptcha: "",
        inProgress: false,
        inProgressFacebook: false,
        inProgressGoogle: false,
        validationEmail: undefined,
        validationPassword: undefined,
        validationPassword2: undefined,
        validationAccept: undefined,
        validationRecaptcha: undefined,
    };
    recaptcha?: Recaptcha
    componentDidMount() {
        $script("https://www.google.com/recaptcha/api.js", "recaptcha");
    }
    changeEmail = (e: React.FormEvent<HTMLInputElement>) => {
        this.setState({ email: e.currentTarget.value, validationEmail: undefined });
    }
    changePassword = (e: React.FormEvent<HTMLInputElement>) => {
        this.setState({ password: e.currentTarget.value, validationPassword: undefined, validationPassword2: undefined });
    }
    changePassword2 = (e: React.FormEvent<HTMLInputElement>) => {
        this.setState({ password2: e.currentTarget.value, validationPassword2: undefined, validationPassword: undefined });
    }
    changeAccept = (e: ICheckboxEvent) => {
        if ((e.target.element as Element).classList.contains("link")) return;
        this.setState({ accept: e.target.checked, validationAccept: undefined });
    };
    signup = () => {
        const { email, password, password2, recaptcha, accept } = this.state;
        const { intl } = this.props;
        if (!email) this.setState({ validationEmail: "required" });
        if (!password) this.setState({ validationPassword: "required" });
        if (!password2) this.setState({ validationPassword2: "required" });
        if (!recaptcha) this.setState({ validationRecaptcha: "required" });
        if (!accept) this.setState({ validationAccept: "required" });
        if (!email || !password || !password2 || !recaptcha || !accept) return;
        if (password !== password2)
            return this.setState({ validationPassword: "passwordDoNotMatch", validationPassword2: "1" });
        if (!reg_email.test(email)) return this.setState({ validationEmail: "incorrectEmailFormat" });
        if (!emailProviderValidator(email)) return this.setState({ validationEmail: "bannedEmailProvider" });
        if (password.length < 8)
            return this.setState({ validationPassword: "passwordTooShort", validationPassword2: "1" });
        this.setState({ inProgress: true });
        this.props.post(
            "signup",
            {
                email,
                password,
                lang: intl.locale,
                "g-recaptcha-response": recaptcha,
            },
            res => {
                const { data } = res;
                if (!data.success) {
                    this.setState({ inProgress: false });
                    this.recaptcha!.reset();
                }
                if (res.status === 403) {
                    this.setState({ recaptcha: "" });
                    this.recaptcha!.reset();
                } else if (data.success) {
                    this.props.editUser(data.user);
                    this.props.history.push((this.app ?( "/" + this.app) : "") + "/" + routing.signupProfile);
                    // window.fbq("track", "CompleteRegistration", {
                    //     value: 0.0,
                    //     currency: "USD",
                    // });
                    // window.gtag('event', 'conversion', {'send_to': 'AW-698573189/HW9UCNL1zvABEIXDjc0C'});
                } else if (data === "emailUsed") {
                    this.setState({ validationEmail: "emailAlreadyUsed" });
                    this.setState({ recaptcha: "" });
                    this.recaptcha!.reset();
                } else if (data === "shortPassword") {
                    this.setState({ validationPassword: "passwordTooShort", validationPassword2: "1" });
                    this.setState({ recaptcha: "" });
                    this.recaptcha!.reset();
                } else if (data === "notInReglist") {
                    this.setState({ validationEmail: "onlyInvitedEmail" });
                    this.setState({ recaptcha: "" });
                    this.recaptcha!.reset();
                } else {
                    this.setState({ validationEmail: "unknownError" });
                }
            },
            () => {
                this.setState({ inProgress: false });
                if (this.recaptcha) {
                    this.recaptcha.reset();
                }
            }
        );
    };
    changeRecaptcha = (e: string) => {
        let validationRecaptcha = undefined;
        if (!e) {
            validationRecaptcha = "required";
        }
        this.setState({ recaptcha: e, validationRecaptcha });
    };
    facebookLoginStarted = () => {
        this.setState({ inProgressFacebook: true });
    };
    facebookLogin = (res: ReactFacebookLoginInfo) => {
        if (!res.accessToken) {
            this.setState({ inProgressFacebook: false, validationEmail: "facebookConnectionError" });
            return;
        }
        const {
            intl: { locale },
        } = this.props;
        this.props.post("facebook-login", { accessToken: res.accessToken, lang: locale }, res => {
            const { data } = res;
            if (data.success) {
                this.props.editUser(data.user);
                this.props.history.push("/" + routing.signupProfile);
                // window.fbq("track", "CompleteRegistration", {
                //     value: 0.0,
                //     currency: "USD",
                // });
            } else {
                this.setState({ inProgressFacebook: false, validationEmail: "facebookConnectionError" });
            }
        });
    };
    googleLoginSuccess = (res: Omit<TokenResponse, "error" | "error_description" | "error_uri">) => {
        this.setState({ inProgressGoogle: true });
        const {
            intl: { locale },
        } = this.props;
        this.props.post("google-login", { accessToken: res.access_token, lang: locale }, res => {
            const { data } = res;
            if (data.success) {
                this.props.editUser(data.user);
                this.props.history.push("/" + routing.signupProfile);
                // window.fbq("track", "CompleteRegistration", {
                //     value: 0.0,
                //     currency: "USD",
                // });
            } else {
                this.setState({ inProgressGoogle: false, validationEmail: "googleConnectionError" });
            }
        });
    };
    googleLoginFailure = () => {
        this.setState({ inProgressGoogle: false, validationEmail: "googleConnectionError" });
    };
    render() {
        const {
            email,
            password,
            password2,
            validationEmail,
            validationPassword,
            validationPassword2,
            validationRecaptcha,
            inProgress,
            inProgressFacebook,
            inProgressGoogle,
            accept,
            validationAccept,
        } = this.state;
        const {
            intl,
            intl: { formatMessage },
        } = this.props;
        const isInProgress = inProgressFacebook || inProgressGoogle || inProgress;
        return (
            <StyledSignup marginTop={50} className={cn("spring--shadow", "spring--padding")}>
                <Seo title={formatMessage(messages.title)} />
                <FormWrapper>
                    <Form disabled={isInProgress}>
                        <h2 style={{ textAlign: "center" }}>
                            <FormattedMessage {...messages.title} />
                        </h2>
                        <Method>
                            <span>
                                <FormattedMessage {...messages.withEmail} />
                            </span>
                        </Method>
                        <InputText
                            email
                            required
                            validation={validationEmail}
                            label={formatMessage(messages.email)}
                            value={email}
                            onChange={this.changeEmail}
                        />
                        <InputPassword
                            required
                            validation={validationPassword}
                            label={formatMessage(messages.password)}
                            value={password}
                            onChange={this.changePassword}
                        />
                        <InputPassword
                            required
                            validation={validationPassword2}
                            label={formatMessage(messages.passwordAgain)}
                            value={password2}
                            onChange={this.changePassword2}
                        />
                        {process.env.WEBPACK && (
                            <StyledRecaptcha className={cn(isInProgress && "RecaptchaDisabled")}>
                                {validationRecaptcha && <Validation validation={validationRecaptcha} />}
                                <Recaptcha
                                    ref={rec => (this.recaptcha = rec!)}
                                    sitekey={recaptchaSiteKey}
                                    render="explicit"
                                    elementID="subscribeRecaptcha"
                                    hl={intl.locale}
                                    onloadCallback={() => null}
                                    verifyCallback={this.changeRecaptcha}
                                    expiredCallback={() => this.changeRecaptcha("")}
                                    onChange={this.changeRecaptcha}
                                    size={window.innerWidth < 360 ? "compact" : "normal"}
                                />
                            </StyledRecaptcha>
                        )}
                        <Checkbox
                            label={
                                <FormattedHTMLMessage
                                    {...messages.acceptTerms}
                                    values={{
                                        termsURL: `${getAppPrefix(this.app)}/` + routing.terms,
                                        privacyURL: `${getAppPrefix(this.app)}/` + routing.privacy,
                                    }}
                                />
                            }
                            checked={accept}
                            validation={validationAccept}
                            onChange={this.changeAccept}
                            disabled={isInProgress}
                        />
                        <Submit onClick={this.signup} loading={isInProgress}>
                            {inProgress ? (
                                <FormattedMessage {...messages.submitInProgress} />
                            ) : (
                                <FormattedMessage {...messages.submit} />
                            )}
                        </Submit>
                        <Method>
                            <span>
                                <FormattedMessage {...messages.withSocial} />
                            </span>
                        </Method>
                        <FacebookLogin
                            appId={facebookAppId}
                            fields={fields}
                            disableMobileRedirect
                            onClick={this.facebookLoginStarted}
                            render={(renderProps: any) => (
                                <Cancel facebook onClick={renderProps.onClick as () => void} disabled={isInProgress}>
                                    <span className={cn("button-facebook button-facebook--dark")}>
                                        <Icon i="facebook" />
                                    </span>
                                    {inProgressFacebook ? (
                                        <FormattedMessage {...messages.facebookConnecting} />
                                    ) : (
                                        <FormattedMessage {...messages.continueWithFacebook} />
                                    )}
                                </Cancel>
                            )}
                            callback={this.facebookLogin}
                        />
                        <GoogleButton
                            googleLoginFailure={this.googleLoginFailure}
                            googleLoginSuccess={this.googleLoginSuccess}
                            inProgressGoogle={inProgressGoogle}
                            isInProgress={isInProgress}
                        />
                    </Form>
                </FormWrapper>
            </StyledSignup>
        );
    }
}

export default Signup;
